import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../../Assets/Css/ConfirmUpload.css";
import backIcon from "../../Assets/Images/Expand_left.png";
const ConfirmUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const initialImages = location.state?.images ?? [];
  const doctorName = location.state?.doctorName ?? "Not Assigned"; // Get doctor name
  const prescribedMedicines = location.state?.prescribedMedicines ?? []; // Get prescribed medicines
  const [images, setImages] = useState(initialImages);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDeleteClick = (index) => {
    const updatedImages = images.filter((_, imgIndex) => imgIndex !== index);
    setImages(updatedImages);
  };

  const handleNextClick = async () => {
    if (images.length === 0) {
      setError("Please upload at least one image.");
      return;
    }

    setLoading(true);
    setError("");

    const formData = new FormData();
    formData.append("category_id", "3");
    formData.append("user_id", "1");
    formData.append("patient_id", "21");

    try {
      images.forEach((image, index) => {
        const blob = base64ToBlob(image);
        formData.append("files[]", blob, `medicine_${index + 1}.jpg`);
      });

      const token = sessionStorage.getItem("authToken");

      if (!token) {
        setError("Authentication token is missing. Please log in again.");
        return;
      }

      const response = await axios.post(
        "https://api.digidoc.co.in/save_medical_records",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      console.log("Upload Success:", response.data);
      navigate("/mapping");
    } catch (err) {
      console.error("Upload Error:", err);
      setError("Failed to upload medical records. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const base64ToBlob = (base64) => {
    const [header, base64Data] = base64.split(',');
    const mimeString = header.split(':')[1].split(';')[0];
    const byteString = atob(base64Data);

    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: mimeString });
  };

  return (
    <div className="capp-container">
      <div className="cupload-container">
        <button className="cback-button" onClick={() => navigate(-1)}>
          <img src={backIcon} alt="Back" className="cicon-image" />
        </button>

        <h2 className="cdoctor-name">Dr. {doctorName}</h2>
        <p className="cprescribed-medicines-heading">Prescribed Medicines</p>
        <ul className="cmedicine-list">
          {prescribedMedicines.length > 0 ? (
            prescribedMedicines.map((med, index) => (
              <li key={index}>{med.medicine_name} - {med.dosage}</li>
            ))
          ) : (
            <li>No medicines prescribed.</li>
          )}
        </ul>

        <div className="cmedicine-list">
          {images.map((image, index) => (
            <div key={index} className="cmedicine-item">
              <label>Medicine {index + 1}</label>
              <div className="cmedicine-info">
                <img
                  src={image}
                  alt={`Medicine ${index + 1}`}
                  className="cmedicine-image"
                />
                <span>Captured Image</span>
                <button
                  className="cdelete-button"
                  onClick={() => handleDeleteClick(index)}
                >
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>

        {error && <p className="cerror-message">{error}</p>}

        <button
          className="cnext-button"
          onClick={handleNextClick}
          disabled={loading}
        >
          {loading ? "Uploading..." : "Next"}
        </button>
      </div>
    </div>
  );
};

export default ConfirmUpload;
